module.exports = __webpack_public_path__ + "static/media/estrellaDammMug.9e3125b2.jpg";